import CarouselContainer from "../../../Components/BonusUi/Carousel/CarouselContainer";

const Carousel = () => {
  return <CarouselContainer />;
};

export default Carousel;
